import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

interface AuthState {
  token: string | null
  setToken: (token: string) => void
  clear: () => void
}

// Resilient storage: localStorage in the browser, an in-memory fallback when
// it's unavailable (SSR / some test envs) so persistence never throws.
const memory = new Map<string, string>()
const fallback = {
  getItem: (k: string) => memory.get(k) ?? null,
  setItem: (k: string, v: string) => void memory.set(k, v),
  removeItem: (k: string) => void memory.delete(k),
}

/**
 * Holds the Tessera bearer token (persisted). Argos has no local login — the
 * token comes from Tessera's OIDC flow (see RequireAuth / LoginPage). UI/client
 * state only; server state lives in TanStack Query.
 */
export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      setToken: (token) => set({ token }),
      clear: () => set({ token: null }),
    }),
    {
      name: 'argos-auth',
      storage: createJSONStorage(() =>
        typeof globalThis !== 'undefined' && globalThis.localStorage ? globalThis.localStorage : fallback,
      ),
    },
  ),
)
